import * as t from './actionTypes';
import { fetchWhatsAppMessagesResponse } from './actions';
import type { WhatsAppMessagesReduxState } from './types';

type WhatsAppMessageReducerActionType = ReturnType<typeof fetchWhatsAppMessagesResponse>;

export const initialWhatsAppMessagesReducerState: WhatsAppMessagesReduxState['insights']['whatsAppMessages'] =
  {
    whatsAppReceivedMessages: [],
  };

const whatsAppMessagesReducer = (
  state = initialWhatsAppMessagesReducerState,
  action: WhatsAppMessageReducerActionType,
) => {
  switch (action.type) {
    case t.FETCH_WHATSAPP_MESSAGES_RESPONSE: {
      return {
        ...state,
        whatsAppReceivedMessages: action.response,
      };
    }
    default: {
      return state;
    }
  }
};

export default whatsAppMessagesReducer;
